var map = {
	"./_avatar-1.jpg": 73,
	"./_avatar-2.jpg": 74,
	"./_avatar-3.jpg": 75,
	"./_avatar-4.jpg": 76,
	"./avatar-1.jpg": 77,
	"./avatar-2.jpg": 78,
	"./avatar-3.jpg": 79,
	"./avatar-4.jpg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;